// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"8e67fd45","297":"4ab5c805","643":"d242cd80"}[chunkId] + ".chunk.js";
};